export const ebookData = {
  title: "Guía Vibracional del Nombre",
  subtitle: "El Mapa de tu Frecuencia Personal",
  author: "Tu Nombre",
  
  chapters: [
    {
      id: 1,
      title: "El Secreto que tu Nombre Intenta Decirte",
      subtitle: "Por qué el alma elige el nombre",
      icon: "🔮",
      hasAudio: false,
      sections: [
        {
          id: "intro-1",
          type: "hero",
          content: "Tu nombre no es accidental. Antes de nacer, tu alma eligió una combinación específica de sonidos, letras y vibraciones que se convertirían en tu identidad terrenal."
        },
        {
          id: "intro-2",
          type: "text",
          content: "Existe un misterio que la mayoría de las personas pasan por alto: cada nombre lleva inscrito un código numérico. Una firma energética única que actúa como una antena: atrae ciertas experiencias, personas, oportunidades y bloquea otras.\n\nTu nombre no es solo una etiqueta. Es un mapa vibracional."
        },
        {
          id: "intro-3",
          type: "quote",
          content: "\"Todo es número.\"",
          author: "Pitágoras"
        },
        {
          id: "intro-4",
          type: "text",
          content: "Los pitagóricos — los mismos matemáticos que descubrieron las propiedades sagradas de los números — sostenían que el universo vibra en frecuencias medibles.\n\nEn la tradición hebrea, cada letra del alfabeto tiene un valor numérico y una cualidad espiritual. Los maestros de la Cábala calculaban el valor numérico de los nombres para revelar el destino.\n\nEn la numerología moderna, esta misma ciencia se ha simplificado pero no perdido su poder: cada letra de tu nombre tiene un número, y esos números revelan tu frecuencia personal."
        },
        {
          id: "intro-5",
          type: "checklist",
          title: "Lo que descubrirás en esta guía:",
          items: [
            "Calcular tu Número Frecuencial Maestro",
            "Identificar las 3 frecuencias bloqueadas",
            "Seguir un protocolo de 7 días para alinear tu energía",
            "Ajustar tu firma o apodo para cambiar tu resonancia"
          ]
        }
      ]
    },
    {
      id: 2,
      title: "Tabla de Conversión Frecuencial",
      subtitle: "El sistema A=1, B=2... y tu Número Frecuencial Maestro",
      icon: "🔢",
      hasAudio: false,
      sections: [
        {
          id: "tabla-1",
          type: "text",
          content: "Usa esta tabla para convertir cada letra de tu nombre en su número correspondiente:"
        },
        {
          id: "tabla-2",
          type: "numberTable",
          data: {
            "A": 1, "B": 2, "C": 3, "D": 4, "E": 5, "F": 6, "G": 7, "H": 8, "I": 9,
            "J": 1, "K": 2, "L": 3, "M": 4, "N": 5, "O": 6, "P": 7, "Q": 8, "R": 9,
            "S": 1, "T": 2, "U": 3, "V": 4, "W": 5, "X": 6, "Y": 7, "Z": 8
          }
        },
        {
          id: "tabla-3",
          type: "calculator",
          title: "Calculadora de Número Frecuencial Maestro",
          description: "Escribe tu nombre (sin apellidos) para calcular tu número:"
        },
        {
          id: "tabla-4",
          type: "masterNumbers",
          title: "Significado de tu Número Frecuencial Maestro",
          numbers: [
            { num: 1, name: "El Líder Cósmico", desc: "Eres pionero, innovador. Tu frecuencia vibra con la creación, la independencia y el poder personal." },
            { num: 2, name: "El Diplomático del Alma", desc: "Tu energía es de cooperación, armonía y sensibilidad. Eres puente entre mundos." },
            { num: 3, name: "El Comunicador Divino", desc: "Creatividad, expresión y alegría son tu sello. Tu nombre te impulsa a crear e inspirar." },
            { num: 4, name: "El Constructor Sagrado", desc: "Disciplina, estructura y estabilidad. Estás aquí para crear bases sólidas." },
            { num: 5, name: "El Caminante del Cambio", desc: "Libertad, aventura y transformación. Tu frecuencia vibra con el movimiento." },
            { num: 6, name: "El Sanador del Corazón", desc: "Amor, familia y servicio. Tu nombre lleva la frecuencia del cuidado y la armonía." },
            { num: 7, name: "El Místico Interior", desc: "Intuición, sabiduría y búsqueda espiritual. Eres canal de conocimiento superior." },
            { num: 8, name: "El Maestro de la Abundancia", desc: "Poder material, éxito y karma. Tu frecuencia vibra con la manifestación financiera." },
            { num: 9, name: "El Humanitario Universal", desc: "Completitud, compasión y servicio. Tu nombre te impulsa a cerrar ciclos." },
            { num: 11, name: "El Maestro Iluminado", desc: "Intuición elevada, visión espiritual y dones psíquicos. Estás aquí para iluminar." },
            { num: 22, name: "El Maestro Constructor", desc: "Capacidad de manifestar sueños grandiosos en la realidad." },
            { num: 33, name: "El Maestro Sanador", desc: "Amor incondicional, servicio desinteresado y elevación colectiva." }
          ]
        }
      ]
    },
    {
      id: 3,
      title: "Diagnóstico de Frecuencias Bloqueadas",
      subtitle: "Identifica qué está deteniendo tu flujo energético",
      icon: "🔒",
      hasAudio: false,
      sections: [
        {
          id: "diag-1",
          type: "text",
          content: "Antes de alinear tu frecuencia, necesitas saber qué la está bloqueando. Existen tres patrones energéticos negativos que operan en la mayoría de las personas sin que lo noten."
        },
        {
          id: "diag-2",
          type: "blockerCard",
          blockerNumber: 1,
          title: "ESCASEZ",
          subtitle: "Frecuencia afectada: Abundancia material y financiera",
          symptoms: [
            "Siempre te falta algo: dinero, tiempo, oportunidades",
            "Sientes que trabajas mucho pero no avanzas",
            "Tienes miedo de gastar o invertir en ti",
            "Comparas tu vida constantemente con la de otros",
            "Cuando algo bueno llega, esperas que se acabe"
          ],
          checklist: [
            "Me preocupo constantemente por el dinero",
            "Siento que nunca es suficiente lo que tengo",
            "Me cuesta pedir lo que valgo",
            "Guardo cosas \"por si acaso\" por miedo",
            "Siento culpa cuando gasto en algo para mí",
            "Creo que los ricos son malos o egoístas",
            "Experimento retrasos persistentes en proyectos",
            "Siento pesadez cuando pienso en mis finanzas"
          ],
          activationThreshold: 3,
          origin: "Este bloqueo generalmente viene de creencias heredadas que se grabaron en tu campo energético como verdades absolutas."
        },
        {
          id: "diag-3",
          type: "blockerCard",
          blockerNumber: 2,
          title: "NIEBLA EMOCIONAL",
          subtitle: "Frecuencia afectada: Claridad mental y dirección de vida",
          symptoms: [
            "No sabes qué quieres realmente",
            "Te sientes perdido/a sin un propósito claro",
            "Dudas constantemente de tus decisiones",
            "Sientes confusión emocional sin razón aparente",
            "Los mismos problemas se repiten en tu vida"
          ],
          checklist: [
            "Me cuesta tomar decisiones importantes",
            "Siento que \"no sé qué hacer con mi vida\"",
            "Cambio de opinión frecuentemente",
            "Me siento abrumado/a por las opciones",
            "Siento que vivo en piloto automático",
            "No distingo mis emociones reales de las de otros",
            "Me afecta fácilmente el ánimo de otros",
            "Siento desconexión con mi intuición"
          ],
          activationThreshold: 3,
          origin: "La niebla emocional se genera cuando no hemos procesado experiencias pasadas o absorbemos las energías de nuestro entorno sin filtro."
        },
        {
          id: "diag-4",
          type: "blockerCard",
          blockerNumber: 3,
          title: "DESALINEAMIENTO",
          subtitle: "Frecuencia afectada: Propósito de vida y conexión espiritual",
          symptoms: [
            "Vives una vida que no sientes tuya",
            "Haces lo que \"debes\" en lugar de lo que tu alma pide",
            "Sientes un vacío que nada parece llenar",
            "Estás en trabajos o relaciones que no te llenan",
            "Sientes que algo te falta pero no sabes qué"
          ],
          checklist: [
            "Mi vida exterior no refleja quién soy realmente",
            "Siento que \"vivo para otros\"",
            "Me cuesta decir la verdad sobre lo que siento",
            "Ignoro mis señales internas",
            "Sigo caminos que no me convencen por costumbre",
            "Siento que desperdicio mi potencial",
            "Me siento desconectado/a de algo superior",
            "Siento que \"algo\" me tiene detenido/a"
          ],
          activationThreshold: 3,
          origin: "El desalineamiento surge cuando priorizamos la aprobación externa sobre la verdad interna."
        },
        {
          id: "diag-5",
          type: "journal",
          title: "Resumen de tu Diagnóstico",
          prompts: [
            "Mi principal bloqueo frecuencial es:",
            "Las 3 palabras que describen mi estado energético actual:",
            "Lo que más deseo manifestar en este momento:"
          ]
        }
      ]
    },
    {
      id: 4,
      title: "Protocolo de 7 Días",
      subtitle: "Plan diario de alineación con tu frecuencia",
      icon: "📅",
      hasAudio: true,
      sections: [
        {
          id: "proto-1",
          type: "text",
          content: "Este protocolo está diseñado para recalibrar tu campo energético en 7 días. Cada día incluye un decrete de poder, una frecuencia específica en Hz y una acción práctica."
        },
        {
          id: "day-1",
          type: "dayCard",
          day: 1,
          title: "PURIFICACIÓN",
          frequency: "432 Hz",
          frequencyName: "La Frecuencia de la Naturaleza",
          decree: "Yo soy [tu nombre]. Mi nombre lleva la luz del universo. Hoy me purifico de toda energía que no me sirve. Abro mi campo a la frecuencia de la verdad. Que mi nombre vibre en armonía con mi alma. Así es, así será, así está hecho.",
          action: "Bebe un vaso de agua con sal marina al despertar. Visualiza cómo la sal arrastra las energías densas.",
          audioTip: "Busca '432 Hz purification' en YouTube y escúchalo 15 minutos."
        },
        {
          id: "day-2",
          type: "dayCard",
          day: 2,
          title: "CONEXIÓN CON TU NÚMERO",
          frequency: "528 Hz",
          frequencyName: "La Frecuencia del Milagro",
          decree: "Mi nombre es mi código sagrado. Cada letra vibra con poder. Cada número revela mi luz. Yo acepto mi frecuencia y permito que transforme mi realidad.",
          action: "Escribe tu nombre y tu Número Frecuencial Maestro en un papel. Colócalo donde lo veas durante el día.",
          audioTip: "528 Hz miracle tone — escúchalo mientras trabajas."
        },
        {
          id: "day-3",
          type: "dayCard",
          day: 3,
          title: "LIBERACIÓN DE ESCASEZ",
          frequency: "888 Hz",
          frequencyName: "La Frecuencia de la Abundancia",
          decree: "Yo merezco abundancia. Mi nombre está alineado con la prosperidad. El universo fluye hacia mí en forma de dinero, oportunidades y alegría. Suelto la escasez. Atraigo la abundancia. Así es, así será, así está hecho.",
          action: "Dona algo — una moneda, un objeto, una sonrisa. La energía de la abundancia fluye cuando damos sin miedo.",
          audioTip: "888 Hz abundance frequency — efectivo al meditar o antes de dormir."
        },
        {
          id: "day-4",
          type: "dayCard",
          day: 4,
          title: "ACTIVACIÓN INTUITIVA",
          frequency: "963 Hz",
          frequencyName: "La Frecuencia de la Conexión Divina",
          decree: "Yo abro mi visión interior. Mi nombre es canal de sabiduría. Confío en mi intuición. Confío en las señales del universo. Mi camino se ilumina ahora.",
          action: "Dedica 10 minutos en silencio total. No celular, no música. Solo tú y tu respiración.",
          audioTip: "963 Hz third eye activation — ideal para meditación matutina."
        },
        {
          id: "day-5",
          type: "dayCard",
          day: 5,
          title: "SANACIÓN EMOCIONAL",
          frequency: "639 Hz",
          frequencyName: "La Frecuencia de las Relaciones",
          decree: "Yo me sanamo. Yo me perdono. Yo me acepto. Mi nombre lleva la frecuencia del amor. Suelto el dolor del pasado. Abrazo la paz del presente. Mi corazón se abre ahora.",
          action: "Escribe una carta de perdón — para ti mismo/a, o para alguien que te hizo daño. No es para enviar, es para soltar.",
          audioTip: "639 Hz healing relationships — especialmente poderoso antes de dormir."
        },
        {
          id: "day-6",
          type: "dayCard",
          day: 6,
          title: "MANIFESTACIÓN",
          frequency: "777 Hz",
          frequencyName: "La Frecuencia de la Suerte Espiritual",
          decree: "Yo soy imán de milagros. Mi nombre está alineado con la magia del universo. Todo lo que deseo ya viene hacia mí. Yo recibo con gratitud. Yo manifiesto con poder. Yo atraigo con fe.",
          action: "Escribe 3 deseos específicos como si ya se hubieran cumplido. No escribas 'quiero', escribe 'agradezco'.",
          audioTip: "777 Hz manifestation — escúchalo mientras lees tus deseos."
        },
        {
          id: "day-7",
          type: "dayCard",
          day: 7,
          title: "INTEGRACIÓN Y SELLO",
          frequency: "888 Hz + 528 Hz",
          frequencyName: "Abundancia + Milagro",
          decree: "Yo soy [tu nombre]. He completado mi recalibración frecuencial. Mi nombre vibra con poder, abundancia y verdad. Estoy alineado/a con mi propósito. Mi frecuencia está activa. Mi vida se transforma ahora.",
          action: "Ritual de cierre: Enciende una vela blanca. Lee tu nombre completo 7 veces. Con cada lectura, visualiza una luz dorada envolviéndote. Sopla la vela con gratitud.",
          audioTip: "Escucha 888 Hz durante 20 minutos para sellar la alineación."
        }
      ]
    },
    {
      id: 5,
      title: "Ajustes de Firma",
      subtitle: "Cómo adaptar apodos o firmas para cambiar tu resonancia",
      icon: "✍️",
      hasAudio: false,
      sections: [
        {
          id: "firma-1",
          type: "text",
          content: "Muchas personas usan apodos, nombres artísticos o variantes de su nombre que no están alineados con su frecuencia óptima.\n\nEl nombre que usas más frecuentemente es el que más influye en tu energía. Si te llamas \"Luis\" pero todos te dicen \"Lucho\", tu frecuencia está siendo modulada por \"Lucho\"."
        },
        {
          id: "firma-2",
          type: "example",
          title: "Ejemplo de cálculo de apodo",
          name: "LUCHO",
          calculation: [
            { letter: "L", value: 3 },
            { letter: "U", value: 3 },
            { letter: "C", value: 3 },
            { letter: "H", value: 8 },
            { letter: "O", value: 6 }
          ],
          total: 23,
          reduced: 5
        },
        {
          id: "firma-3",
          type: "checklist",
          title: "¿Cuándo conviene cambiar de firma?",
          items: [
            "Si tu nombre legal vibra en un número de bloqueo",
            "Si sientes que tu nombre no \"te queda\"",
            "Si estás en un proceso de transformación de vida",
            "Si quieres potenciar una cualidad específica"
          ]
        },
        {
          id: "firma-4",
          type: "steps",
          title: "Cómo elegir un nombre o firma alineada",
          steps: [
            "Identifica el número que necesitas potenciar (ej: abundancia = 8)",
            "Busca letras que sumen tu número deseado",
            "Elige combinaciones que suenen bien y se sientan auténticas",
            "Prueba la nueva firma durante 21 días",
            "Observa los cambios en tu energía y circunstancias"
          ]
        }
      ]
    },
    {
      id: 6,
      title: "BONUS: La Frecuencia del Dinero",
      subtitle: "Códigos de Abundancia para desbloquear la escasez financiera",
      icon: "💰",
      hasAudio: true,
      bonus: true,
      sections: [
        {
          id: "dinero-1",
          type: "hero",
          content: "El dinero es energía. Y como toda energía, vibra en una frecuencia específica. Los 3 códigos numéricos que aprenderás están diseñados para sintonizarte con la frecuencia de la abundancia."
        },
        {
          id: "dinero-2",
          type: "codeCard",
          title: "CÓDIGO 1: El Código 8-8-8",
          subtitle: "El código maestro de la abundancia material",
          code: "888",
          instructions: [
            "Cada mañana, escribe '888' en un papel",
            "Coloca el papel en tu billetera o lugar donde guardes dinero",
            "Antes de dormir, sostén el papel y di 3 veces:",
            "888 — Yo sintonizo con la frecuencia de la abundancia. El dinero fluye hacia mí fácilmente y en cantidades crecientes."
          ],
          duration: "21 días consecutivos"
        },
        {
          id: "dinero-3",
          type: "codeCard",
          title: "CÓDIGO 2: El Código 3-6-9",
          subtitle: "El código de activación de oportunidades",
          code: "369",
          instructions: [
            "Cada vez que vayas a tomar una decisión financiera, repite mentalmente: '3-6-9'",
            "Al despertar, escribe 3 cantidades de dinero que deseas recibir",
            "Junta esas cifras y reduce a un solo dígito",
            "Si el resultado es tu número frecuencial, la oportunidad está alineada"
          ],
          duration: "Uso continuo"
        },
        {
          id: "dinero-4",
          type: "codeCard",
          title: "CÓDIGO 3: El Código 4-8-12",
          subtitle: "El código de estabilidad financiera",
          code: "4812",
          instructions: [
            "El día 4 de cada mes: haz una acción de prosperidad",
            "El día 8 de cada mes: revisa tus finanzas con gratitud",
            "El día 12 de cada mes: escribe una meta financiera para el mes siguiente"
          ],
          duration: "3 meses de ciclos mensuales"
        },
        {
          id: "dinero-5",
          type: "decreeList",
          title: "Decretos Diarios de Prosperidad",
          decrees: [
            "El dinero es mi aliado. Me busca, me sirve y me multiplica.",
            "Yo soy un imán de prosperidad. Todo lo que toco se convierte en abundancia.",
            "Merezco recibir riqueza en todas sus formas.",
            "Mi cuenta bancaria es un espejo de mi frecuencia interior. Yo elijo abundancia.",
            "Cada día soy más próspero/a. Cada mes mis ingresos aumentan.",
            "Suelto todo miedo al dinero. Confío en que el universo siempre me provee.",
            "Yo no persigo al dinero. El dinero me persigue a mí.",
            "Mi nombre vibra con abundancia. Mi frecuencia atrae prosperidad."
          ]
        }
      ]
    },
    {
      id: 7,
      title: "BONUS: La Fórmula Corporal Energética",
      subtitle: "Elevar la vitalidad y alinear los chakras",
      icon: "⚡",
      hasAudio: true,
      bonus: true,
      sections: [
        {
          id: "corporal-1",
          type: "hero",
          content: "No eres solo carne y huesos. Eres un campo electromagnético vivo. Cuando tu campo está desbalanceado, sientes cansancio, pesadez y desconexión."
        },
        {
          id: "corporal-2",
          type: "steps",
          title: "Rutina de 5 Minutos al Despertar",
          steps: [
            "ENRAIZAMIENTO (1 min): Pies en el suelo. Visualiza raíces conectándose con la Tierra. Di: 'Yo estoy seguro/a. Yo estoy presente.'",
            "ACTIVACIÓN DEL FUEGO (1 min): Manos sobre el abdomen. Imagina una esfera de fuego dorado. Di: 'Mi poder interior se activa.'",
            "APERTURA DEL CORAZÓN (1 min): Manos sobre el pecho. Visualiza luz verde esmeralda. Di: 'Mi corazón se abre. El amor fluye.'",
            "TERCER OJO (1 min): Toca el punto entre las cejas. Visualiza luz índigo. Di: 'Mi visión interior se activa.'",
            "CONEXIÓN CON LA CORONA (1 min): Manos sobre la cabeza sin tocarla. Visualiza luz blanca descendiendo. Di: 'Yo estoy conectado/a con el universo.'"
          ]
        },
        {
          id: "corporal-3",
          type: "exercise",
          title: "Ritual de Activación del Agua",
          description: "Coloca un vaso de agua frente a ti. Sostén tu nombre sobre el vaso y di 3 veces:",
          decree: "Agua sagrada, recibe la frecuencia de mi nombre. Lleva esta energía purificadora a cada célula de mi cuerpo. Limpia lo que no sirve. Activa lo que necesita florecer.",
          duration: "21 días"
        },
        {
          id: "corporal-4",
          type: "exercise",
          title: "Balance del Campo Electromagnético",
          description: "Extiende los brazos. Gira 7 veces en sentido horario. Con cada giro, visualiza luz dorada limpiando tu campo. Al terminar, sacude tus manos.",
          decree: "Limpio. Limpio. Limpio. Mi campo está puro y protegido.",
          duration: "2 minutos — usar después de multitudes o conflictos"
        }
      ]
    },
    {
      id: 8,
      title: "BONUS: Escudo Anti-Envidia",
      subtitle: "Protección contra el mal de ojo y vibraciones densas",
      icon: "🛡️",
      hasAudio: false,
      bonus: true,
      sections: [
        {
          id: "escudo-1",
          type: "hero",
          content: "El 'mal de ojo' no es un mito. Es una realidad energética documentada por culturas de todo el mundo durante miles de años. La protección energética es necesaria."
        },
        {
          id: "escudo-2",
          type: "checklist",
          title: "Señales de que estás afectado/a:",
          items: [
            "Dolor de cabeza o malestar repentina",
            "Mala racha inexplicable después de un éxito",
            "Enfermedades frecuentes sin causa aparente",
            "Sueños pesados o pesadillas recurrentes",
            "Sensación de ser 'observado/a'",
            "Pérdida de energía después de estar con ciertas personas",
            "Las cosas buenas 'se arruinan' cuando las compartes"
          ]
        },
        {
          id: "escudo-3",
          type: "prayer",
          title: "Oración de Protección Matutina",
          text: "En el nombre de la luz eterna, yo me cubro con mi escudo sagrado. Que ninguna energía negativa penetre mi campo. Que ninguna mirada de envidia me alcance. Que ningún pensamiento oscuro toque mi espíritu. Yo soy luz. La luz no puede ser manchada. Mi ángel guardián me protege. Mi nombre vibra en seguridad. Así es. Así será. Así está hecho."
        },
        {
          id: "escudo-4",
          type: "prayer",
          title: "Decreto del Escudo de Fuego",
          text: "¡ESTOY PROTEGIDO/A! Mi campo es fuego sagrado. Quien intente enviarme energía negativa, recibirá su propia energía de vuelta. Quien me mire con envidia, verá solo luz. Yo soy inviolable. Soy intocable. Soy sagrado/a. Mi escudo de fuego arde ahora. Mi protección es absoluta. Así es y así será por siempre."
        },
        {
          id: "escudo-5",
          type: "exercise",
          title: "Ritual de Limpieza del Hogar",
          steps: [
            "Disuelve sal marina en agua y pasa el paño por puertas y ventanas",
            "Coloca sal en las 4 esquinas de tu casa por 24 horas",
            "Enciende una vela blanca y decreta la protección de tu espacio",
            "Deja que la vela se consuma completamente"
          ],
          decree: "Este hogar es sagrado. Solo el amor habita aquí. Solo la paz florece aquí. Solo la abundancia entra aquí. Protección total. Bendición total. Paz total."
        }
      ]
    },
    {
      id: 9,
      title: "BONUS: Rituales de Amor",
      subtitle: "Elevar tu frecuencia para atraer relaciones armónicas",
      icon: "💕",
      hasAudio: true,
      bonus: true,
      sections: [
        {
          id: "amor-1",
          type: "hero",
          content: "El amor no es solo una emoción. Es una frecuencia. Si has atraído relaciones tóxicas, el problema no es 'mala suerte'. Es tu frecuencia vibracional."
        },
        {
          id: "amor-2",
          type: "calculator",
          title: "Calculadora de Compatibilidad Numérica",
          description: "Calcula tu número y el de tu pareja para ver si son compatibles:"
        },
        {
          id: "amor-3",
          type: "compatibilityTable",
          title: "Guía de Compatibilidad",
          data: [
            { type: "Mismo número", result: "Alta compatibilidad — se entienden intuitivamente" },
            { type: "Números que suman 9", result: "Complementarios — se completan mutuamente" },
            { type: "Números maestros", result: "Conexión especial — relación con propósito espiritual" },
            { type: "Números opuestos", result: "Retos y crecimiento — requiere trabajo pero transforma" },
            { type: "Números consecutivos", result: "Evolución juntos — aprenden el uno del otro" }
          ]
        },
        {
          id: "amor-4",
          type: "prayer",
          title: "Decreto para Atraer Relaciones Armónicas",
          text: "Yo, [tu nombre], invoco la frecuencia del amor verdadero. No el amor que duele, sino el amor que sana. Atraigo a mi vida una persona que vibra en la misma luz que yo. Una persona que me respeta, me valora y me ama como merezco ser amado/a. Nuestros campos se alinean. Nuestras almas se reconocen. Yo estoy listo/a. El universo escucha. El amor llega. Así es, así será, así está hecho."
        },
        {
          id: "amor-5",
          type: "checklist",
          title: "Prácticas para Elevar tu Frecuencia Amorosa",
          items: [
            "Escucha música en 639 Hz — La frecuencia de las relaciones",
            "Rodea tu cama de pétalos de rosa una vez al mes",
            "Escribe cartas de amor a ti mismo/a",
            "Planta una rosa en tu hogar — cuidarla es cuidar tu frecuencia",
            "Usa el color rosa en tu ropa durante 21 días"
          ]
        }
      ]
    },
    {
      id: 10,
      title: "BONUS: Ritual de Luna Nueva",
      subtitle: "Aprovecha el poder de cada luna para manifestar tus deseos",
      icon: "🌙",
      hasAudio: true,
      bonus: true,
      sections: [
        {
          id: "luna-1",
          type: "hero",
          content: "La Luna Nueva es el momento más poderoso del mes para sembrar intenciones. Tu frecuencia personal, combinada con el能量 lunar, crea una fuerza manifestadora extraordinaria."
        },
        {
          id: "luna-2",
          type: "text",
          content: "Cada mes, durante la Luna Nueva, el universo abre una ventana de 48 horas donde tus intenciones tienen el poder de crecer exponencialmente.\n\nLa Luna Nueva representa el inicio de un nuevo ciclo. Es como una página en blanco donde puedes escribir lo que desees manifestar en los próximos 29 días."
        },
        {
          id: "luna-3",
          type: "steps",
          title: "Ritual de Luna Nueva Paso a Paso",
          steps: [
            "PREPARACIÓN: Limpia tu espacio. Enciende una vela blanca y una vela del color de tu intención (verde=abundancia, rosa=amor, azul=comunicación).",
            "CONEXIÓN: Siéntate cómodamente. Cierra los ojos. Respira 7 veces profundamente. Con cada exhalación, libera lo que ya no necesitas.",
            "ESCRITURA SACRA: Escribe tu intención en presente. Ejemplo: 'Agradezco haber recibido $5000 este mes' o 'Agradezco tener una relación amorosa y armónica'.",
            "VISUALIZACIÓN: Sostén tu papel con las manos. Visualiza tu deseo como ya cumplido. Siente la emoción de haberlo recibido.",
            "DECRETO: Lee tu intención en voz alta 7 veces. Con cada lectura, siente la energía creciendo.",
            "SELLADO: Dobla el papel hacia ti (para atraer). Colócalo bajo tu almohada o en un lugar especial. Déjalo hasta la Luna Llena.",
            "CIERRE: Agradece al universo. Apaga la vela soplando con gratitud. Confía en que el proceso está en marcha."
          ]
        },
        {
          id: "luna-4",
          type: "decreeList",
          title: "Decretos de Luna Nueva por Área",
          decrees: [
            "ABUNDANCIA: 'La Luna Nueva activa mi campo de prosperidad. Todo lo que toco se multiplica. El dinero fluye hacia mí en cantidades crecientes.'",
            "AMOR: 'La Luna Nueva abre mi corazón al amor verdadero. Atraigo una relación que honre mi alma. Mi frecuencia amorosa se eleva ahora.'",
            "SALUD: 'La Luna Nueva regenera mi cuerpo. Cada célula se renueva. Salud, vitalidad y energía fluyen en mí.'",
            "PROPOSITO: 'La Luna Nueva ilumina mi camino. Mi propósito de vida se revela. Sigo la guía de mi alma con confianza.'",
            "PROTECCIÓN: 'La Luna Nueva activa mi escudo de luz. Ninguna energía negativa me alcanza. Estoy protegido/a por el universo.'"
          ]
        },
        {
          id: "luna-5",
          type: "exercise",
          title: "Mandala de Luna Nueva",
          description: "Dibuja un círculo en un papel. Dentro, escribe tu número frecuencial Maestro en el centro. Alrededor, escribe tu intención. Decorá con líneas que irradien hacia afuera. Coloca la fecha de la Luna Nueva. Guarda este mandala como amuleto del mes.",
          duration: "15 minutos — crear tu mandala mensual"
        }
      ]
    },
    {
      id: 11,
      title: "RECURSOS DESCARGABLES",
      subtitle: "Materiales complementarios para tu práctica diaria",
      icon: "📥",
      hasAudio: false,
      bonus: false,
      isResources: true,
      sections: [
        {
          id: "recursos-1",
          type: "resourcesList",
          title: "Tu Kit de Recursos Espirituales",
          resources: [
            {
              name: "Decretos de Poder (PDF Imprimible)",
              description: "Todos los decretos del ebook organizados por área: abundancia, amor, protección, salud y propósito. Imprime y coloca en tu espacio sagrado.",
              icon: "📜",
              type: "pdf"
            },
            {
              name: "Tabla de Conversión Frecuencial (Carta de Referencia)",
              description: "Tarjeta con la tabla A=1, B=2 para tener siempre a mano. Tamaño tarjeta de crédito.",
              icon: "🔢",
              type: "pdf"
            },
            {
              name: "Checklist de Diagnóstico (Imprimible)",
              description: "Las 3 páginas de checklists de bloqueos frecuenciales para hacer tu diagnóstico en papel.",
              icon: "✅",
              type: "pdf"
            },
            {
              name: "Calendario de Lunas 2026",
              description: "Fechas exactas de Lunas Nuevas y Llenas del año para planificar tus rituales.",
              icon: "📅",
              type: "pdf"
            },
            {
              name: "Wallpapers Vibracionales (5 diseños)",
              description: "Fondos de pantalla para celular con frases y números de poder. Incluye: 432Hz, 528Hz, 888Hz, 963Hz y tu número frecuencial.",
              icon: "📱",
              type: "images"
            },
            {
              name: "Guía Rápida de Frecuencias (Cheat Sheet)",
              description: "Resumen de todas las frecuencias Hz y cuándo usar cada una. Referencia rápida.",
              icon: "📋",
              type: "pdf"
            }
          ]
        },
        {
          id: "recursos-2",
          type: "text",
          content: "Todos estos recursos están diseñados para complementar tu práctica espiritual diaria. Los PDFs están optimizados para imprimir en tamaño carta.\n\nLos wallpapers están en resolución 1080x1920 (formato vertical para celular).\n\nDescarga todo desde el enlace que recibirás por correo después de tu compra."
        }
      ]
    }
  ]
}
